import { hasReachedSessionLimit, isUnlimitedSessionLimit, normalizeUserAccess } from '@/lib/user-access';

export { hasReachedSessionLimit, isUnlimitedSessionLimit };

export type SessionLoadStatus = 'idle' | 'loading' | 'ready' | 'error';
export type NewSessionRestriction = 'loading' | 'unavailable' | 'limit' | null;

export function getSessionLimit(access: unknown): number {
  return normalizeUserAccess(access).session_limit;
}

export function canManageSessions(access: unknown): boolean {
  return normalizeUserAccess(access).can_manage_sessions;
}

export function getNewSessionRestriction(
  access: unknown,
  currentSessionCount: number,
  sessionStatus: SessionLoadStatus,
): NewSessionRestriction {
  if (sessionStatus === 'error') return 'unavailable';
  if (sessionStatus !== 'ready') return 'loading';
  return hasReachedSessionLimit(access, currentSessionCount) ? 'limit' : null;
}
